<template>
  <BaseVeeForm
    :action="submitForm"
    v-slot="{ isPending, isRejected, invalid }"
    @success="$emit('success')"
    @failure="$emit('failure')"
  >
    <BaseCard>
      <BaseCardBody>
        <div class="space-y-6">
          <ValidationProvider rules="required" name="email" tag="div" vid="email">
            <template #default="{ errors, failed }">
              <BaseFormGroup>
                <BaseFormLabel>Email address</BaseFormLabel>
                <BaseFormInput type="email" v-model="formData.email" :disabled="isPending" />
                <BaseFormInlineMessage v-if="failed" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </template>
          </ValidationProvider>

          <ValidationProvider rules="required" name="password" tag="div" vid="password">
            <template #default="{ errors, failed }">
              <BaseFormGroup>
                <BaseFormLabel>Password</BaseFormLabel>
                <BaseFormInput type="password" v-model="formData.password" :disabled="isPending" />
                <BaseFormInlineMessage v-if="failed" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </template>
          </ValidationProvider>

          <p class="text-sm text-right">
            <RouterLink to="/forgot-password"> Forgot password </RouterLink>
          </p>
        </div>
      </BaseCardBody>
      <BaseCardBody>
        <BaseButton primary class="w-full" :disabled="invalid || isPending || isRejected">
          Login
        </BaseButton>
      </BaseCardBody>
    </BaseCard>
  </BaseVeeForm>
</template>

<script>
export default {
  name: 'LoginForm',

  data() {
    return {
      formData: {
        email: '',
        password: '',
      },
    };
  },

  methods: {
    async submitForm() {
      const {
        $store: { dispatch },
        formData,
      } = this;

      try {
        await dispatch({
          type: 'ui/auth/login',
          formData,
        });

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
